(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-promo"]) return;
  try {
    
  class AppPromo extends HTMLElement {
    static storageKey = 'app-promo-dismissed-at';
    static snoozeMs = 30 * 24 * 60 * 60 * 1000;
    static delayMs = 4000;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.shouldShow()) return;

      this.querySelectorAll('[data-app-promo-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.querySelector('[data-app-promo-download]')?.addEventListener('click', () => this.dialog.close());
      // A tap on the dimmed backdrop lands on the dialog element itself.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      // Escape, the buttons, the backdrop and the download link all end here.
      this.dialog.addEventListener('close', () => this.snooze());

      setTimeout(() => {
        if (!document.querySelector('dialog[open]')) this.dialog.showModal();
      }, AppPromo.delayMs);
    }

    shouldShow() {
      if (!/iPhone|iPod/.test(navigator.userAgent)) return false;
      if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return false;
      try {
        const dismissedAt = Number(localStorage.getItem(AppPromo.storageKey));
        if (dismissedAt && Date.now() - dismissedAt < AppPromo.snoozeMs) return false;
      } catch (error) {
        // Storage blocked (private mode): show it, the visitor can still close it.
      }
      return true;
    }

    snooze() {
      try {
        localStorage.setItem(AppPromo.storageKey, String(Date.now()));
      } catch (error) {
        // Nothing to remember it in; it will show again next visit.
      }
    }
  }
  customElements.define('app-promo', AppPromo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-index"] && !Shopify.designMode) return;
  try {
    
  // Filters the A-Z grid in place. Every chip is a working link before this
  // runs — the letters jump to their anchor and "Toutes" reloads the
  // unfiltered page — so a reader without JavaScript loses the filtering and
  // nothing else. No cell is hidden until someone asks for it.
  class BrandIndex extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-brand-grid]');
      if (!this.grid) return;

      this.cells = Array.from(this.grid.querySelectorAll('[data-brand-letter]'));
      this.chips = Array.from(this.querySelectorAll('[data-filter-letter], [data-filter-all]'));
      this.meta = this.querySelector('[data-brand-meta]');
      if (this.cells.length === 0 || this.chips.length === 0) return;

      this.active = '';
      this.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-filter-letter], [data-filter-all]');
        if (!chip || !this.contains(chip)) return;
        event.preventDefault();
        const letter = chip.dataset.filterLetter || '';
        // Clicking the letter that is already on clears it, so the rail
        // resets itself as well as "Toutes" does.
        this.apply(letter === this.active ? '' : letter);
      });

      this.mark();
    }

    apply(letter) {
      this.active = letter;
      for (const cell of this.cells) {
        cell.hidden = letter !== '' && cell.dataset.brandLetter !== letter;
      }
      this.mark();
    }

    mark() {
      let source = null;
      for (const chip of this.chips) {
        const isActive = (chip.dataset.filterLetter || '') === this.active;
        chip.classList.toggle('brand-index__letter--selected', isActive);
        if (isActive) {
          chip.setAttribute('aria-current', 'true');
          source = chip;
        } else {
          chip.removeAttribute('aria-current');
        }
      }
      if (this.meta && source && source.dataset.brandLabel) {
        this.meta.textContent = source.dataset.brandLabel;
      }
    }
  }

  customElements.define('brand-index', BrandIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) this.close();
        if (event.target.closest('[data-cart-close-on-nav]')) this.close();
        const qtyBtn = event.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          this.changeQuantity(qtyBtn.dataset.cartQty, qtyBtn.dataset.qty);
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      });
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          this.open();
        }
      });
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.removeAttribute('data-closing');
      this.setAttribute('open', '');
      this.setAttribute('data-animating', '');
      const panel = this.querySelector('.cart-drawer__panel');
      const done = () => {
        clearTimeout(fallback);
        this.removeAttribute('data-animating');
      };
      const fallback = setTimeout(done, 550);
      if (panel) panel.addEventListener('animationend', done, { once: true });
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      if (!this.hasAttribute('open')) return;
      if (this.hasAttribute('data-closing')) return;
      this.removeAttribute('data-animating');
      this.setAttribute('data-closing', '');
      const panel = this.querySelector('.cart-drawer__panel');
      const done = () => {
        clearTimeout(fallback);
        this.removeAttribute('open');
        this.removeAttribute('data-closing');
        document.documentElement.style.overflow = '';
      };
      const fallback = setTimeout(done, 250);
      if (panel) panel.addEventListener('animationend', done, { once: true });
    }

    get routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async changeQuantity(line, quantity) {
      const response = await fetch(this.routesRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      if (response.ok) await this.refresh();
    }

    async refresh(openAfter) {
      const response = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      const data = await response.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('cart-drawer');
      if (fresh) {
        const wasOpen = this.hasAttribute('open');
        this.innerHTML = fresh.innerHTML;
        this.dataset.itemCount = fresh.dataset.itemCount;
        if (wasOpen || openAfter) this.open();
      }
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = this.dataset.itemCount;
      });
      // The count is in the refreshed markup; the header's money total is not.
      if (window.ForYouCart) window.ForYouCart.refresh();
      document.dispatchEvent(new CustomEvent('cart:refreshed'));
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');
        try {
          const root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            body: new FormData(form),
          });
          if (!response.ok) {
            const error = await response.json().catch(() => null);
            if (error && error.description) alert(error.description);
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          if (drawer) await drawer.refresh(true);
        } finally {
          if (button) button.removeAttribute('aria-busy');
        }
      });
    }
  }
  customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-checkout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Inline mode on the cart template: the form is revealed by the
    // #commande hash (and stays visible after a successful order).
    const inline = document.querySelector('[data-cod-inline]');
    if (inline) {
      const cartSection = document.querySelector('.cart-page');
      const apply = () => {
        const done = inline.querySelector('[data-cod-success]:not([hidden])');
        const show = window.location.hash === '#commande' || Boolean(done);
        inline.hidden = !show;
        if (cartSection) cartSection.style.display = show ? 'none' : '';
        if (show) window.scrollTo(0, 0);
      };
      apply();
      window.addEventListener('hashchange', apply);
    }

    // Submit: create a real Shopify order through the ForYou API. The
    // line items are read from the live cart at submit time so an edited
    // cart in another tab cannot desynchronize the order.
    const form = document.getElementById('cod-checkout-form');
    if (form) {
      const apiBase = (form.dataset.apiBase || '').replace(/\/+$/, '');
      const errors = form.querySelector('[data-cod-errors]');
      const submitBtn = form.querySelector('[data-cod-submit]');
      let currentLabel = submitBtn ? submitBtn.textContent : '';

      const fail = () => {
        if (errors) {
          errors.textContent = form.dataset.errorLabel;
          errors.hidden = false;
          errors.scrollIntoView({ block: 'center' });
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = currentLabel;
        }
      };

      // Discount code: validated and priced by the ForYou API, re-checked
      // server-side when the order is created.
      const coupon = form.querySelector('[data-cod-coupon]');
      let appliedDiscount = null;

      const formatMoney = (amount) => {
        const template = form.dataset.moneyTemplate || '';
        const value = amount.toFixed(2);
        return template.includes('[amount]') ? template.replace('[amount]', value) : value + ' MAD';
      };

      const updateTotals = () => {
        const subtotal = Number(form.dataset.subtotal) || 0;
        const shipping = Number(form.dataset.shippingPrice) || 0;
        const discount = appliedDiscount ? Math.min(appliedDiscount.amount, subtotal) : 0;
        const total = Math.max(subtotal + shipping - discount, 0);
        const grandTotal = form.querySelector('[data-cod-grand-total]');
        if (grandTotal) grandTotal.textContent = formatMoney(total);
        if (submitBtn && submitBtn.dataset.labelTemplate) {
          currentLabel = submitBtn.dataset.labelTemplate.replace('[total]', formatMoney(total));
          if (!submitBtn.disabled) submitBtn.textContent = currentLabel;
        }
      };

      if (coupon) {
        const row = coupon.querySelector('[data-cod-coupon-row]');
        const input = coupon.querySelector('[data-cod-coupon-input]');
        const applyBtn = coupon.querySelector('[data-cod-coupon-apply]');
        const errorBox = coupon.querySelector('[data-cod-coupon-error]');
        const errorText = coupon.querySelector('[data-cod-coupon-error-text]');
        const appliedBox = coupon.querySelector('[data-cod-coupon-applied]');
        const appliedCode = coupon.querySelector('[data-cod-coupon-code]');
        const appliedAmount = coupon.querySelector('[data-cod-coupon-amount]');
        const removeBtn = coupon.querySelector('[data-cod-coupon-remove]');
        const discountRow = form.querySelector('[data-cod-discount-row]');

        const showError = (message) => {
          if (errorText) errorText.textContent = message;
          if (errorBox) errorBox.hidden = false;
          input.classList.add('cod-checkout__coupon-input--invalid');
        };

        const clearError = () => {
          if (errorBox) errorBox.hidden = true;
          input.classList.remove('cod-checkout__coupon-input--invalid');
        };

        const render = () => {
          if (row) row.hidden = Boolean(appliedDiscount);
          if (appliedBox) appliedBox.hidden = !appliedDiscount;
          if (discountRow) {
            discountRow.hidden = !appliedDiscount;
            if (appliedDiscount) {
              const label = discountRow.querySelector('[data-cod-discount-label]');
              const amount = discountRow.querySelector('[data-cod-discount-amount]');
              if (label) {
                label.textContent = (discountRow.dataset.rowLabel || '[code]').replace('[code]', appliedDiscount.code);
              }
              if (amount) amount.textContent = '−' + formatMoney(appliedDiscount.amount);
            }
          }
          if (appliedDiscount) {
            if (appliedCode) appliedCode.textContent = appliedDiscount.code;
            if (appliedAmount) appliedAmount.textContent = '−' + formatMoney(appliedDiscount.amount);
          }
          updateTotals();
        };

        const apply = () => {
          const code = input.value.trim();
          if (!code || applyBtn.disabled) return;
          clearError();
          applyBtn.disabled = true;

          // The live cart is read at apply time so product-scoped codes are
          // priced against what is actually in the cart.
          fetch(root + 'cart.js')
            .then((r) => r.json())
            .then(async (cart) => {
              const subtotal =
                (cart.items_subtotal_price || 0) / 100 || Number(form.dataset.subtotal) || 0;
              const response = await fetch(apiBase + '/api/storefront/discounts/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  code: code,
                  subtotal: subtotal,
                  line_items: (cart.items || []).map((item) => ({
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                  })),
                }),
              });
              const data = await response.json().catch(() => ({}));
              if (response.ok && data.valid) {
                appliedDiscount = { code: data.code, amount: Number(data.amount) || 0 };
                // Persist so the cart page and drawer show the same discount.
                if (window.ForYouDiscount) {
                  window.ForYouDiscount.save({
                    code: appliedDiscount.code,
                    amount: appliedDiscount.amount,
                    subtotal: subtotal,
                  });
                  window.ForYouDiscount.syncAll();
                }
                input.value = '';
                render();
                return;
              }
              if (response.status === 422) {
                const details = data.errors || {};
                const reasons = details.code || [];
                if (details.minimum_subtotal) {
                  showError(
                    (coupon.dataset.minimumLabel || '').replace(
                      '[amount]',
                      formatMoney(Number(details.minimum_subtotal) || 0)
                    )
                  );
                } else if (reasons.indexOf('not_applicable') !== -1) {
                  showError(coupon.dataset.notApplicableLabel);
                } else {
                  showError(coupon.dataset.invalidLabel);
                }
                return;
              }
              showError(form.dataset.errorLabel);
            })
            .catch(() => showError(form.dataset.errorLabel))
            .finally(() => {
              applyBtn.disabled = false;
            });
        };

        applyBtn.addEventListener('click', apply);
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            apply();
          }
        });
        input.addEventListener('input', clearError);
        if (removeBtn) {
          removeBtn.addEventListener('click', () => {
            appliedDiscount = null;
            if (window.ForYouDiscount) {
              window.ForYouDiscount.clear();
              window.ForYouDiscount.syncAll();
            }
            render();
          });
        }

        // A code applied earlier in the session is restored on load —
        // re-priced by the API if the cart changed in between.
        const restoreDiscount = () => {
          if (!window.ForYouDiscount || appliedDiscount) return;
          const current =
            Number(form.dataset.itemsSubtotal) || Number(form.dataset.subtotal) || 0;
          window.ForYouDiscount.resolve(apiBase, current).then((discount) => {
            if (discount && !appliedDiscount) {
              appliedDiscount = { code: discount.code, amount: discount.amount };
              render();
            }
          });
        };
        // Deferred until DOMContentLoaded so the shared helper (bundled in
        // arbitrary order) is guaranteed to be defined.
        if (document.readyState === 'complete') {
          restoreDiscount();
        } else {
          document.addEventListener('DOMContentLoaded', restoreDiscount);
        }
      }

      // Purchase tracking. Orders are created by the ForYou API, so the
      // storefront never reaches Shopify's checkout and no `checkout_completed`
      // event is ever emitted for a COD order. Without this, the only Purchase
      // Meta sees is whatever was tagged by hand on the place-order button —
      // one hardcoded amount repeated on every order. Publish the real basket
      // instead, so each event carries its own value.
      const publishPurchase = (cart, data, fields) => {
        if (!window.ForYouMeta) return;

        const subtotal = (Number(cart.total_price) || 0) / 100;
        const shipping = Number(form.dataset.shippingPrice) || 0;
        const discount = appliedDiscount ? Math.min(appliedDiscount.amount, subtotal) : 0;

        // Computed from the same three numbers the order is created with, so
        // the reported value always equals the order total — rather than the
        // API's `total_price`, whose unit (cents or dirhams) is not guaranteed.
        const total = Math.max(subtotal + shipping - discount, 0);

        // Built in snippets/meta-attribution.liquid, which the express modal
        // on the product page uses too — one place decides what a COD
        // purchase looks like, and above all what its `event_id` is.
        //
        // Nothing is sent to window.fbq here. The Facebook & Instagram app
        // pixel runs in the page rather than a sandbox, so window.fbq does
        // exist — and a Purchase fired through it wins the deduplication race
        // against the relay, which means Meta keeps the copy carrying only
        // whatever its automatic matching scraped off the form and drops the
        // one carrying `user_data`. One sender, and it is the relay.
        window.ForYouMeta.publishPurchase({
          orderId: data.order_id || data.order_number || data.id,
          value: total,
          currency: form.dataset.currency,
          contents: cart.items.map((item) => ({
            id: String(item.variant_id),
            quantity: item.quantity,
            item_price: Number(((Number(item.final_price) || 0) / 100).toFixed(2)),
          })),
          identity: window.ForYouMeta.identity({
            first_name: fields.get('first_name'),
            last_name: fields.get('last_name'),
            phone: fields.get('phone'),
            city: fields.get('city'),
            email: fields.get('email'),
          }),
        });
      };

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submitBtn && submitBtn.disabled) return;
        if (errors) errors.hidden = true;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = form.dataset.sendingLabel;
        }

        const fields = new FormData(form);
        let orderedCart = null;

        // Posted with the order so the Api can attach the ad click to the
        // server-side Purchase. It cannot read these cookies itself — it is
        // served from another host. See snippets/meta-attribution.liquid.
        const attribution = window.ForYouMeta ? window.ForYouMeta.attribution() : {};

        fetch(root + 'cart.js')
          .then((r) => r.json())
          .then((cart) => {
            if (!cart.items || cart.items.length === 0) throw new Error('empty cart');
            orderedCart = cart;
            return fetch(apiBase + '/api/storefront/orders', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                first_name: fields.get('first_name'),
                last_name: fields.get('last_name'),
                phone: fields.get('phone'),
                address: fields.get('address'),
                city: fields.get('city'),
                email: (fields.get('email') || '').trim() || null,
                newsletter: Boolean(fields.get('newsletter')),
                fbp: attribution.fbp || null,
                fbc: attribution.fbc || null,
                shipping_price: Number(form.dataset.shippingPrice) || 0,
                discount_code: appliedDiscount ? appliedDiscount.code : null,
                line_items: cart.items.map((item) => ({
                  variant_id: item.variant_id,
                  quantity: item.quantity,
                })),
              }),
            });
          })
          .then(async (response) => {
            if (!response.ok) throw new Error('api ' + response.status);
            const data = await response.json().catch(() => ({}));

            const grid = form.querySelector('.cod-checkout__grid');
            if (grid) grid.style.display = 'none';
            const success = document.querySelector('[data-cod-success]');
            const numberEl = document.querySelector('[data-cod-order-number]');
            if (numberEl && data.order_number) {
              numberEl.textContent = numberEl.dataset.template.replace('[number]', data.order_number);
              numberEl.hidden = false;
            }
            if (success) success.hidden = false;
            window.scrollTo(0, 0);

            // After the confirmation renders: a tracking failure must not be
            // reported to the customer as a failed order.
            try {
              if (orderedCart) publishPurchase(orderedCart, data, fields);
            } catch (e) {
              /* ignored */
            }

            if (window.ForYouDiscount) window.ForYouDiscount.clear();

            // Empty the cart so the order is not re-submitted. clear.js
            // answers with the emptied cart, so the header badge is set from
            // what actually happened rather than from an assumed zero.
            fetch(root + 'cart/clear.js', { method: 'POST' })
              .then((r) => r.json())
              .then((cart) => {
                if (window.ForYouCart) {
                  window.ForYouCart.apply(cart);
                  return;
                }
                document.querySelectorAll('[data-cart-count]').forEach((el) => {
                  el.textContent = '0';
                });
              })
              .catch(() => {
                /* the order is placed; a stale badge is not worth an error */
              });
          })
          .catch(fail);
      });
    }

    // Mobile: summary starts collapsed; desktop: always open.
    const summary = document.querySelector('[data-cod-summary]');
    if (summary) {
      const mq = window.matchMedia('(min-width: 990px)');
      const apply = () => {
        summary.open = mq.matches ? true : summary.open;
        if (mq.matches) summary.open = true;
      };
      apply();
      mq.addEventListener('change', apply);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class SortSelect extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      if (!select) return;
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }
  customElements.define('sort-select', SortSelect);

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('[data-facet-form]');
      if (!form) return;
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]')) form.requestSubmit();
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
        window.location.href = window.location.pathname + '?' + params.toString();
      });
    }
  }
  customElements.define('facet-filters', FacetFilters);

  // Clamps the collection description on narrow screens, and only when it
  // actually runs past three lines. The class is applied here rather than in
  // the stylesheet so that the paragraph is whole for a reader without
  // JavaScript, and so a two-line description never grows a button that
  // reveals nothing.
  const CLAMPED = 'collection-page__meta--clamped';

  class CollectionMeta extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-meta-text]');
      this.toggle = this.querySelector('[data-meta-toggle]');
      if (!this.text || !this.toggle) return;

      this.expanded = false;
      this.narrow = window.matchMedia('(max-width: 989px)');
      this.sync = this.sync.bind(this);

      this.toggle.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.render();
      });

      // `change` fires on rotation and on a resize across the breakpoint,
      // without the scroll-blocking cost of listening to every resize frame.
      if (this.narrow.addEventListener) this.narrow.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (this.narrow && this.narrow.removeEventListener) {
        this.narrow.removeEventListener('change', this.sync);
      }
    }

    sync() {
      if (!this.narrow.matches) {
        this.overflows = false;
        this.expanded = false;
        this.render();
        return;
      }
      // Measure against the clamp itself: with the overflow hidden,
      // scrollHeight is still the height the full text would take.
      this.text.classList.add(CLAMPED);
      this.overflows = this.text.scrollHeight - this.text.clientHeight > 2;
      this.render();
    }

    render() {
      const clamp = this.overflows && !this.expanded;
      this.text.classList.toggle(CLAMPED, clamp);
      this.toggle.hidden = !this.overflows;
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      const label = this.expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
      if (label) this.toggle.textContent = label;
    }
  }
  customElements.define('collection-meta', CollectionMeta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (Number.isNaN(end)) return;
      const hoursEl = this.querySelector('[data-countdown-hours]');
      const minutesEl = this.querySelector('[data-countdown-minutes]');
      const secondsEl = this.querySelector('[data-countdown-seconds]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = Math.max(0, end - Date.now());
        const totalSeconds = Math.floor(diff / 1000);
        hoursEl.textContent = pad(Math.floor(totalSeconds / 3600));
        minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        secondsEl.textContent = pad(totalSeconds % 60);
        if (diff === 0) clearInterval(this.timer);
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }
  customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // The badge in the header is the only place the cart total appears on
    // every page, and nothing in the theme could update it — the amount
    // rendered at page load sat there through adds, removals and completed
    // orders until the next full reload. Anything that changes the cart calls
    // this.
    //
    // `[data-cart-total]` in the cart page and drawer is a different number:
    // it includes shipping. This deliberately does not touch it.
    window.ForYouCart = {
      format: function (cents) {
        const link = document.querySelector('[data-cart-open]');
        const template = (link && link.dataset.moneyFormat) || '{' + '{amount}' + '}';
        const amount = (Number(cents) / 100)
          .toFixed(2)
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return template.replace(/\{\{\s*amount[^}]*\}\}/, amount);
      },

      // `cart` is the object /cart.js and /cart/*.js return.
      apply: function (cart) {
        if (!cart) return cart;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
          el.textContent = window.ForYouCart.format(cart.total_price);
        });
        return cart;
      },

      root: function () {
        const link = document.querySelector('[data-cart-open]');
        return (link && link.dataset.rootUrl) || '/';
      },

      refresh: function () {
        return fetch(this.root() + 'cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            return window.ForYouCart.apply(cart);
          })
          .catch(function () {
            // A stale badge is not worth surfacing an error for.
            return null;
          });
      },
    };

    function closeDrawer(drawer) {
      if (!drawer.open || drawer.hasAttribute('data-closing')) return;
      drawer.setAttribute('data-closing', '');
      const done = () => {
        clearTimeout(fallback);
        drawer.close();
        drawer.removeAttribute('data-closing');
      };
      const fallback = setTimeout(done, 250);
      drawer.addEventListener('animationend', done, { once: true });
    }

    document.addEventListener('click', function (event) {
      const drawer = document.querySelector('[data-menu-drawer]');
      if (!drawer) return;
      if (event.target.closest('[data-menu-open]')) {
        drawer.showModal();
        // iOS draws a focus ring on the auto-focused close button.
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
      } else if (event.target.closest('[data-menu-close]')) {
        closeDrawer(drawer);
      } else if (event.target === drawer) {
        closeDrawer(drawer);
      }
    });

    document.addEventListener(
      'cancel',
      function (event) {
        if (event.target.matches && event.target.matches('[data-menu-drawer]')) {
          event.preventDefault();
          closeDrawer(event.target);
        }
      },
      true
    );
  })();

  class CatalogDropdown extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-catalog-toggle]');
      this.panel = this.querySelector('[data-catalog-panel]');
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => {
        if (this.panel.hidden) {
          this.open();
        } else {
          this.close();
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.panel.hidden && !this.contains(event.target)) this.close();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          this.close();
          this.toggle.focus();
        }
      });
    }

    open() {
      this.panel.removeAttribute('data-closing');
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (this.panel.hidden) return;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('data-closing', '');
      const finish = () => {
        clearTimeout(fallback);
        this.panel.removeEventListener('animationend', finish);
        this.panel.hidden = true;
        this.panel.removeAttribute('data-closing');
      };
      const fallback = setTimeout(finish, 150);
      this.panel.addEventListener('animationend', finish);
    }
  }
  customElements.define('catalog-dropdown', CatalogDropdown);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      this.clearButton = this.querySelector('[data-search-clear]');
      this.form = this.querySelector('form');
      if (!this.input || !this.results) return;

      let timer;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        this.clearButton.hidden = this.input.value.length === 0;
        timer = setTimeout(() => this.search(), 250);
      });

      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.clearButton.hidden = true;
        this.hide();
        this.input.focus();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.hide();
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.hide();
      });

      if (this.form) {
        this.form.addEventListener('submit', () => {
          this.input.value = this.normalize(this.input.value);
        });
      }

      const select = this.querySelector('[data-category-select]');
      if (select && this.form) {
        this.form.addEventListener('submit', (event) => {
          if (select.value && this.input.value.trim() === '') {
            event.preventDefault();
            window.location.href = select.value;
          }
        });
      }
    }

    hide() {
      this.results.hidden = true;
    }

    // Shopify's index splits FY-3C44X7 at the hyphen, so the code typed
    // without it ("fy3c44x7") matches nothing. Put the hyphen back; any other
    // query passes through untouched.
    normalize(value) {
      const code = value.match(/^\s*fy[\s_-]*([0-9a-z]{6})\s*$/i);
      return code ? 'FY-' + code[1].toUpperCase() : value;
    }

    async search() {
      const query = this.normalize(this.input.value.trim());
      if (query.length < 2) {
        this.hide();
        return;
      }
      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,query',
        'resources[limit]': '6',
        section_id: 'predictive-search',
      });
      try {
        const response = await fetch(root + 'search/suggest?' + params.toString());
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const inner = doc.querySelector('.predictive-results');
        if (inner) {
          this.results.innerHTML = '';
          this.results.appendChild(inner);
          this.results.hidden = false;
        }
      } catch (error) {
        /* network hiccup: keep the previous suggestions */
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.slideTo));
          this.restart();
        });
      });

      const seconds = Number(this.dataset.autoplay || 0);
      if (seconds > 0) {
        this.delay = seconds * 1000;
        this.armAutoplay();
      }
    }

    // Autoplay starts on the first interaction, not on load.
    //
    // Largest Contentful Paint keeps accepting new candidates until the
    // visitor first taps, scrolls or presses a key. A slideshow that advances
    // on its own before that paints a fresh hero image every few seconds, and
    // on a phone the taller slide's image is a larger candidate than the first
    // one, so the metric moved from 1.8 s to 9.5 s on the home page while
    // nothing visible was slow. The events below are the ones that close the
    // LCP window in Chrome; a visitor who never does any of them was never
    // going to watch the slides change.
    armAutoplay() {
      this.autoplayEvents = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'];
      this.autoplayOptions = { passive: true, capture: true };
      this.startAutoplay = () => {
        this.disarmAutoplay();
        this.restart();
      };
      this.autoplayEvents.forEach((type) => {
        window.addEventListener(type, this.startAutoplay, this.autoplayOptions);
      });
    }

    disarmAutoplay() {
      if (!this.startAutoplay) return;
      this.autoplayEvents.forEach((type) => {
        window.removeEventListener(type, this.startAutoplay, this.autoplayOptions);
      });
      this.startAutoplay = null;
    }

    disconnectedCallback() {
      this.disarmAutoplay();
      clearInterval(this.timer);
    }

    restart() {
      if (!this.delay) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.show((this.index + 1) % this.slides.length);
      }, this.delay);
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('hero__dot--active', i === index);
      });
    }
  }
  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Accordions: shadcn-style — animated height, one open at a time.
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.product-page__accordion summary');
    if (!summary) return;
    event.preventDefault();
    const item = summary.closest('.product-page__accordion');
    const group = item.closest('.product-page__accordions');
    const wasExpanded = item.hasAttribute('data-expanded');
    group.querySelectorAll('.product-page__accordion').forEach((acc) => {
      acc.removeAttribute('data-expanded');
      const s = acc.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
    if (!wasExpanded) {
      item.setAttribute('data-expanded', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  });

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb-index]');
        if (!thumb) return;
        this.showFrame(thumb.dataset.thumbIndex);
      });
    }

    showFrame(index) {
      const frames = Array.from(this.querySelectorAll('[data-media-index]'));
      if (!frames.some((frame) => frame.dataset.mediaIndex === index)) return;
      this.querySelectorAll('[data-thumb-index]').forEach((thumb) => {
        const active = thumb.dataset.thumbIndex === index;
        thumb.classList.toggle('product-page__thumb--active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      frames.forEach((frame) => {
        frame.hidden = frame.dataset.mediaIndex !== index;
      });
    }

    showVariantMedia(media) {
      if (!media) return;
      const frame = Array.from(this.querySelectorAll('[data-media-id]')).find(
        (candidate) => candidate.dataset.mediaId === String(media.id)
      );
      if (frame) this.showFrame(frame.dataset.mediaIndex);
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class QtyInput extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      this.querySelector('[data-qty-minus]').addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value) - 1);
      });
      this.querySelector('[data-qty-plus]').addEventListener('click', () => {
        input.value = Number(input.value) + 1;
      });
    }
  }
  customElements.define('qty-input', QtyInput);

  class ProductPage extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-variants-json]');
      if (!json) return;
      try {
        this.variants = JSON.parse(json.textContent);
      } catch (error) {
        return;
      }
      this.moneyFormat = document.documentElement.dataset.moneyFormat || null;
      this.querySelectorAll('.product-page__option input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
      this.refreshOptionAvailability();
      this.initExpress();
      this.purgeEmptyAppWrappers();
    }

    // App embeds (e.g. Hextom Ultimate Sales Boost) inject wrapper divs
    // around the form after load; when they carry no visible content they
    // still double the column's flex gap — remove them from the DOM.
    purgeEmptyAppWrappers() {
      const purge = () => {
        this.querySelectorAll('[class*="htusb"]').forEach((el) => {
          const hasContent =
            el.textContent.trim() !== '' || el.querySelector('img, svg, iframe, canvas, video');
          if (!hasContent) el.remove();
        });
      };
      purge();
      const observer = new MutationObserver(purge);
      observer.observe(this, { childList: true, subtree: true });
    }

    selectedVariant() {
      if (!this.variants || !this.variants.length) return null;
      const fieldsets = this.querySelectorAll('.product-page__option');
      if (!fieldsets.length) return this.variants[0];
      const selected = [];
      fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : null;
      });
      return (
        this.variants.find((candidate) =>
          candidate.options.every((value, index) => value === selected[index])
        ) || this.variants[0]
      );
    }

    initExpress() {
      this.modal = this.querySelector('[data-express-modal]');
      if (!this.modal) return;
      this.xQty = 1;
      this.xDiscount = null;
      // The line a discount was priced against. A quote is only good for the
      // line it was quoted for.
      this.xDiscountSignature = null;
      this.initExpressCoupon();

      const buyNow = this.querySelector('[data-buy-now]');
      if (buyNow) {
        buyNow.addEventListener('click', (event) => {
          event.preventDefault();
          if (buyNow.hasAttribute('aria-disabled')) return;
          this.openExpress();
        });
      }

      this.modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-express-close]')) {
          this.closeExpress();
        } else if (event.target === this.modal) {
          this.closeExpress();
        } else if (event.target.closest('[data-x-qty-minus]')) {
          this.xQty = Math.max(1, this.xQty - 1);
          this.syncExpressTotals();
        } else if (event.target.closest('[data-x-qty-plus]')) {
          this.xQty += 1;
          this.syncExpressTotals();
        }
      });

      this.modal.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeExpress();
      });

      const form = this.modal.querySelector('#express-checkout-form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.submitExpress(form);
        });
      }
    }

    submitExpress(form) {
      const submitBtn = form.querySelector('[data-x-submit]');
      if (submitBtn && submitBtn.disabled) return;
      const errors = form.querySelector('[data-express-errors]');
      const defaultLabel = submitBtn ? submitBtn.innerHTML : '';
      if (errors) errors.hidden = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = form.dataset.sendingLabel;
      }

      const variant = this.selectedVariant();
      const qty = this.xQty;
      const subtotal = variant.price * qty;
      const threshold = parseInt(this.modal.dataset.freeThreshold, 10) || 0;
      let shipping = parseInt(this.modal.dataset.shippingPrice, 10) || 0;
      if (threshold > 0 && subtotal >= threshold) shipping = 0;
      // Shown to the shopper; the Api re-resolves the code against Shopify
      // when it creates the order, so this is never what they are charged on.
      const discount = this.xDiscount ? Math.min(this.xDiscount.amount, subtotal) : 0;
      const total = Math.max(subtotal + shipping - discount, 0);

      const apiBase = (form.dataset.apiBase || '').replace(/\/+$/, '');
      const fields = new FormData(form);
      // An express order never publishes a browser Purchase, so the server
      // event is the only one Meta gets — these are what let it attribute it.
      const attribution = window.ForYouMeta ? window.ForYouMeta.attribution() : {};

      fetch(apiBase + '/api/storefront/orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          first_name: fields.get('first_name'),
          last_name: fields.get('last_name'),
          phone: fields.get('phone'),
          address: fields.get('address'),
          city: fields.get('city'),
          email: (fields.get('email') || '').trim() || null,
          newsletter: Boolean(fields.get('newsletter')),
          fbp: attribution.fbp || null,
          fbc: attribution.fbc || null,
          discount_code: this.xDiscount ? this.xDiscount.code : null,
          shipping_price: shipping / 100,
          line_items: [{ variant_id: variant.id, quantity: qty }],
        }),
      })
        .then(async (response) => {
          if (!response.ok) throw new Error('api ' + response.status);
          const data = await response.json().catch(() => ({}));
          form.classList.add('express-modal__form--done');
          const numberEl = form.querySelector('[data-x-order-number]');
          if (numberEl && data.order_number) {
            numberEl.textContent = numberEl.dataset.template.replace('[number]', data.order_number);
            numberEl.hidden = false;
          }
          const success = form.querySelector('[data-express-success]');
          if (success) success.hidden = false;

          // The same event the cart checkout publishes. Until now this was
          // the one path that reported nothing at all: an express order
          // never reached Shopify's checkout and never published here
          // either, so Meta saw no Purchase for it whatsoever. The Api's
          // Conversions API copy carries the same event_id, so the pair is
          // counted once.
          try {
            if (window.ForYouMeta) {
              window.ForYouMeta.publishPurchase({
                orderId: data.order_id || data.order_number || data.id,
                value: total / 100,
                contents: [
                  {
                    id: String(variant.id),
                    quantity: qty,
                    item_price: Number((variant.price / 100).toFixed(2)),
                  },
                ],
                identity: window.ForYouMeta.identity({
                  first_name: fields.get('first_name'),
                  last_name: fields.get('last_name'),
                  phone: fields.get('phone'),
                  city: fields.get('city'),
                  email: fields.get('email'),
                }),
              });
            }
          } catch (error) {
            // Tracking must never block the order confirmation.
          }

          // They have just bought this line. Leaving it in the cart invites a
          // second order of the same thing, and leaves the header badge
          // showing money for something already paid for. Only this line is
          // removed — the rest of the cart is not what they bought.
          if (window.ForYouCart) {
            const cartRoot = window.ForYouCart.root();
            fetch(cartRoot + 'cart.js')
              .then((response) => response.json())
              .then((cart) => {
                const present = (cart.items || []).some((item) => item.variant_id === variant.id);
                if (!present) return cart;
                return fetch(cartRoot + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: String(variant.id), quantity: 0 }),
                }).then((response) => response.json());
              })
              .then((cart) => window.ForYouCart.apply(cart))
              .catch(() => {
                /* the order is placed; a stale badge is not worth an error */
              });
          }
        })
        .catch(() => {
          if (errors) {
            errors.textContent = form.dataset.errorLabel;
            errors.hidden = false;
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = defaultLabel;
          }
        });
    }

    openExpress() {
      const qtyInput = this.querySelector('.product-page__qty input');
      this.xQty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      this.syncExpress();
      this.modal.removeAttribute('data-closing');
      if (!this.modal.open) {
        this.modal.showModal();
        // iOS draws a focus ring on the auto-focused close button.
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
      }
    }

    closeExpress() {
      if (!this.modal.open || this.modal.hasAttribute('data-closing')) return;
      this.modal.setAttribute('data-closing', '');
      const done = () => {
        clearTimeout(fallback);
        this.modal.close();
        this.modal.removeAttribute('data-closing');
      };
      const fallback = setTimeout(done, 150);
      this.modal.addEventListener('animationend', done, { once: true });
    }

    syncExpress() {
      const variant = this.selectedVariant();
      if (!variant) return;
      const meta = this.modal.querySelector('[data-x-meta]');
      if (meta) {
        const parts = [];
        if (variant.title && variant.title !== 'Default Title') parts.push(variant.title);
        if (this.modal.dataset.vendor) parts.push(this.modal.dataset.vendor);
        meta.textContent = parts.join(' · ');
      }
      const img = this.modal.querySelector('[data-x-image]');
      if (img && variant.featured_image && variant.featured_image.src) {
        img.src = variant.featured_image.src;
      }
      const priceEl = this.modal.querySelector('[data-x-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(variant.price);
      this.syncExpressTotals();
    }

    syncExpressTotals() {
      const variant = this.selectedVariant();
      if (!variant) return;
      const qtyEl = this.modal.querySelector('[data-x-qty]');
      if (qtyEl) qtyEl.textContent = this.xQty;

      const subtotal = variant.price * this.xQty;
      const threshold = parseInt(this.modal.dataset.freeThreshold, 10) || 0;
      let shipping = parseInt(this.modal.dataset.shippingPrice, 10) || 0;
      // Free shipping is judged on the basket before the code, the same way
      // the cart checkout does it.
      if (threshold > 0 && subtotal >= threshold) shipping = 0;
      const discount = this.xDiscount ? Math.min(this.xDiscount.amount, subtotal) : 0;
      const total = Math.max(subtotal + shipping - discount, 0);
      const shippingText = shipping === 0 ? this.modal.dataset.freeText : this.formatMoney(shipping);

      const set = (selector, text, freeBadge) => {
        const el = this.modal.querySelector(selector);
        if (!el) return;
        if (freeBadge) {
          el.innerHTML = '<span class="badge badge--success">' + text + '</span>';
        } else {
          el.textContent = text;
        }
      };
      set('[data-x-subtotal]', this.formatMoney(subtotal));
      set('[data-x-shipping]', shippingText, shipping === 0);
      set('[data-x-shipping-method]', shippingText, shipping === 0);
      set('[data-x-total]', this.formatMoney(total));
      set('[data-x-submit-total]', this.formatMoney(total));

      const discountRow = this.modal.querySelector('[data-x-discount-row]');
      if (discountRow) {
        discountRow.hidden = !this.xDiscount;
        if (this.xDiscount) {
          const label = discountRow.querySelector('[data-x-discount-label]');
          const amount = discountRow.querySelector('[data-x-discount-amount]');
          if (label) {
            label.textContent = (discountRow.dataset.rowLabel || '[code]').replace(
              '[code]',
              this.xDiscount.code
            );
          }
          if (amount) amount.textContent = '−' + this.formatMoney(discount);
        }
      }

      this.revalidateExpressDiscount();
    }

    initExpressCoupon() {
      const coupon = this.modal.querySelector('[data-x-coupon]');
      if (!coupon) return;
      this.xCoupon = coupon;

      const input = coupon.querySelector('[data-x-coupon-input]');
      const applyBtn = coupon.querySelector('[data-x-coupon-apply]');
      const removeBtn = coupon.querySelector('[data-x-coupon-remove]');

      const apply = () => this.applyExpressDiscount(input ? input.value.trim() : '');

      if (applyBtn) applyBtn.addEventListener('click', apply);
      if (input) {
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            apply();
          }
        });
        input.addEventListener('input', () => this.clearExpressCouponError());
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', () => {
          this.xDiscount = null;
          this.xDiscountSignature = null;
          this.clearExpressCouponError();
          this.renderExpressCoupon();
        });
      }
    }

    showExpressCouponError(message) {
      if (!this.xCoupon) return;
      const box = this.xCoupon.querySelector('[data-x-coupon-error]');
      const text = this.xCoupon.querySelector('[data-x-coupon-error-text]');
      const input = this.xCoupon.querySelector('[data-x-coupon-input]');
      if (text) text.textContent = message || '';
      if (box) box.hidden = false;
      if (input) input.classList.add('express-modal__coupon-input--invalid');
    }

    clearExpressCouponError() {
      if (!this.xCoupon) return;
      const box = this.xCoupon.querySelector('[data-x-coupon-error]');
      const input = this.xCoupon.querySelector('[data-x-coupon-input]');
      if (box) box.hidden = true;
      if (input) input.classList.remove('express-modal__coupon-input--invalid');
    }

    renderExpressCoupon() {
      if (this.xCoupon) {
        const row = this.xCoupon.querySelector('[data-x-coupon-row]');
        const applied = this.xCoupon.querySelector('[data-x-coupon-applied]');
        const code = this.xCoupon.querySelector('[data-x-coupon-code]');
        const amount = this.xCoupon.querySelector('[data-x-coupon-amount]');

        if (row) row.hidden = Boolean(this.xDiscount);
        if (applied) applied.hidden = !this.xDiscount;
        if (this.xDiscount) {
          if (code) code.textContent = this.xDiscount.code;
          if (amount) amount.textContent = '−' + this.formatMoney(this.xDiscount.amount);
        }
      }
      this.syncExpressTotals();
    }

    /**
     * Prices a code against the single line in the modal. `silent` is the
     * re-quote after the shopper changed that line: it must not clear an
     * error they have not seen yet, but it may still drop a code that has
     * stopped applying — a total the API would not honour is worse than none.
     */
    applyExpressDiscount(code, options) {
      const variant = this.selectedVariant();
      if (!code || !variant || !this.xCoupon) return;

      const silent = Boolean(options && options.silent);
      const applyBtn = this.xCoupon.querySelector('[data-x-coupon-apply]');
      const input = this.xCoupon.querySelector('[data-x-coupon-input]');
      const form = this.modal.querySelector('#express-checkout-form');
      const apiBase = ((form && form.dataset.apiBase) || '').replace(/\/+$/, '');
      const qty = this.xQty;
      const signature = variant.id + ':' + qty;

      if (!silent) this.clearExpressCouponError();
      if (applyBtn) applyBtn.disabled = true;

      fetch(apiBase + '/api/storefront/discounts/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          code: code,
          subtotal: (variant.price * qty) / 100,
          line_items: [{ variant_id: variant.id, quantity: qty }],
        }),
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));

          if (response.ok && data.valid) {
            this.xDiscount = {
              code: data.code,
              // The API answers in the shop's currency; everything in this
              // modal is in cents.
              amount: Math.round((Number(data.amount) || 0) * 100),
            };
            this.xDiscountSignature = signature;
            if (input) input.value = '';
            this.clearExpressCouponError();
            this.renderExpressCoupon();
            return;
          }

          this.xDiscount = null;
          this.xDiscountSignature = null;
          this.renderExpressCoupon();

          if (response.status === 422) {
            const details = data.errors || {};
            const reasons = details.code || [];
            if (details.minimum_subtotal) {
              this.showExpressCouponError(
                (this.xCoupon.dataset.minimumLabel || '').replace(
                  '[amount]',
                  this.formatMoney(Math.round((Number(details.minimum_subtotal) || 0) * 100))
                )
              );
            } else if (reasons.indexOf('not_applicable') !== -1) {
              this.showExpressCouponError(this.xCoupon.dataset.notApplicableLabel);
            } else {
              this.showExpressCouponError(this.xCoupon.dataset.invalidLabel);
            }
            return;
          }

          this.showExpressCouponError(form && form.dataset.errorLabel);
        })
        .catch(() => {
          this.xDiscount = null;
          this.xDiscountSignature = null;
          this.renderExpressCoupon();
          this.showExpressCouponError(form && form.dataset.errorLabel);
        })
        .finally(() => {
          if (applyBtn) applyBtn.disabled = false;
        });
    }

    /**
     * A percentage code scales with quantity and a minimum-subtotal code can
     * stop qualifying, so a change to the line re-quotes rather than carrying
     * the old amount over. Debounced: the quantity buttons repeat quickly and
     * the endpoint is rate limited.
     */
    revalidateExpressDiscount() {
      if (!this.xDiscount) return;
      const variant = this.selectedVariant();
      if (!variant) return;
      if (variant.id + ':' + this.xQty === this.xDiscountSignature) return;

      const code = this.xDiscount.code;
      clearTimeout(this.xDiscountTimer);
      this.xDiscountTimer = setTimeout(() => {
        this.applyExpressDiscount(code, { silent: true });
      }, 300);
    }

    formatMoney(cents) {
      const amount = (cents / 100)
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      const fallback = '{' + '{amount}' + '}';
      const template = this.dataset.moneyFormat || fallback;
      return template.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    onOptionChange() {
      const selected = [];
      this.querySelectorAll('.product-page__option').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : null;
      });
      const variant = this.variants.find((candidate) =>
        candidate.options.every((value, index) => value === selected[index])
      );
      if (!variant) return;

      this.querySelector('product-gallery')?.showVariantMedia(variant.featured_media);

      const idInput = this.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      const priceEl = this.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(variant.price);

      const compareEl = this.querySelector('[data-compare-price]');
      const saveBadge = this.querySelector('[data-save-badge]');
      const discountBadge = this.querySelector('[data-discount-badge]');
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = this.formatMoney(variant.compare_at_price);
      }
      if (saveBadge) {
        saveBadge.hidden = !onSale;
        const saveAmount = this.querySelector('[data-save-amount]');
        if (onSale && saveAmount) {
          saveAmount.textContent = this.formatMoney(variant.compare_at_price - variant.price);
        }
      }
      if (priceEl) priceEl.classList.toggle('product-page__price--sale', Boolean(onSale));
      if (discountBadge && onSale) {
        discountBadge.textContent =
          '-' + Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '%';
      }

      const skuEl = this.querySelector('[data-sku]');
      if (skuEl) {
        skuEl.hidden = !variant.sku;
        const skuValue = skuEl.querySelector('[data-sku-value]');
        if (skuValue) skuValue.textContent = variant.sku || '';
      }

      const availability = this.querySelector('[data-availability]');
      const atc = this.querySelector('[data-atc]');
      if (availability) {
        availability.classList.toggle('product-page__availability--out', !variant.available);
        availability.textContent = variant.available
          ? availability.dataset.inStockText || availability.textContent
          : availability.dataset.soldOutText || availability.textContent;
      }
      if (atc) {
        atc.disabled = !variant.available;
        const atcPrice = this.querySelector('[data-atc-price]');
        if (atcPrice) atcPrice.textContent = this.formatMoney(variant.price);
      }

      const buyNow = this.querySelector('[data-buy-now]');
      if (buyNow) {
        if (variant.available) {
          buyNow.removeAttribute('aria-disabled');
          buyNow.removeAttribute('tabindex');
        } else {
          buyNow.setAttribute('aria-disabled', 'true');
          buyNow.setAttribute('tabindex', '-1');
        }
        // No variant in the href any more — it points at the COD form, which
        // is the same page whichever variant is selected.
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      this.refreshOptionAvailability();
    }

    // A value is sold out when no available variant matches it combined
    // with the values currently selected in the other options.
    refreshOptionAvailability() {
      if (!this.variants || !this.variants.length) return;
      const fieldsets = Array.from(this.querySelectorAll('.product-page__option'));
      if (!fieldsets.length) return;
      const selected = [];
      fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : null;
      });
      fieldsets.forEach((fieldset) => {
        const position = Number(fieldset.dataset.optionPosition) - 1;
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          const candidate = selected.slice();
          candidate[position] = input.value;
          const matches = (variant) =>
            variant.options.every((value, index) => candidate[index] === null || value === candidate[index]);
          // Sold-out combinations stay selectable so shoppers can see their
          // price (add to cart is disabled instead); only combinations with
          // no variant at all are disabled.
          const exists = this.variants.some(matches);
          const available = this.variants.some((variant) => variant.available && matches(variant));
          input.disabled = !exists;
          input
            .closest('.product-page__option-value')
            .classList.toggle('product-page__option-value--soldout', !available);
        });
      });
    }
  }
  customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.load();
        },
        { rootMargin: '200px' }
      );
      observer.observe(this);
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('related-products');
        if (fresh && fresh.innerHTML.trim() !== '') {
          this.innerHTML = fresh.innerHTML;
        }
      } catch (error) {
        /* recommendations are optional; fail silently */
      }
    }
  }
  customElements.define('related-products', RelatedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchCodeRedirect extends HTMLElement {
    connectedCallback() {
      if (this.dataset.url) window.location.replace(this.dataset.url);
    }
  }
  customElements.define('search-code-redirect', SearchCodeRedirect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  class GoogleReviews extends HTMLElement {
    connectedCallback() {
      this.apiKey = this.dataset.apiKey;
      this.placeId = this.dataset.placeId;
      this.minRating = parseInt(this.dataset.minRating, 10) || 4;
      if (!this.apiKey || !this.placeId) return;
      // The Maps JS bundle is ~380 KiB: only load it once the section
      // approaches the viewport instead of on page load.
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.loadMaps().then(() => this.fetchReviews()).catch(() => {});
        },
        { rootMargin: '400px' }
      );
      observer.observe(this);
    }

    loadMaps() {
      if (window.google && window.google.maps && window.google.maps.places) {
        return Promise.resolve();
      }
      if (window.__gmapsPromise) return window.__gmapsPromise;
      window.__gmapsPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const lang = (document.documentElement.lang || 'fr').split('-')[0];
        script.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(this.apiKey) +
          '&libraries=places&language=' +
          encodeURIComponent(lang);
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.__gmapsPromise;
    }

    fetchReviews() {
      const service = new google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails(
        { placeId: this.placeId, fields: ['reviews', 'rating', 'user_ratings_total'] },
        (place, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !place) return;
          const reviews = (place.reviews || [])
            .filter((review) => review.rating >= this.minRating)
            .slice(0, 4);
          if (reviews.length === 0) return;
          this.render(place, reviews);
        }
      );
    }

    render(place, reviews) {
      const list = this.querySelector('[data-review-list]');
      if (!list) return;
      list.innerHTML = '';
      reviews.forEach((review) => {
        const card = document.createElement('div');
        card.className = 'social-proof__review';
        const head = document.createElement('div');
        head.className = 'social-proof__review-head';
        const name = document.createElement('b');
        name.textContent = review.author_name;
        const date = document.createElement('span');
        date.textContent = review.relative_time_description || '';
        head.appendChild(name);
        head.appendChild(date);
        const text = document.createElement('p');
        let body = review.text || '';
        if (body.length > 220) body = body.slice(0, 217).trimEnd() + '…';
        text.textContent = body;
        card.appendChild(head);
        card.appendChild(text);
        list.appendChild(card);
      });

      if (place.rating) {
        const score = this.querySelector('[data-score]');
        if (score) score.textContent = String(place.rating).replace('.', ',');
      }
      if (place.user_ratings_total) {
        const caption = this.querySelector('[data-score-caption]');
        const template = this.dataset.captionTemplate;
        if (caption && template) {
          caption.textContent = template.replace('[count]', place.user_ratings_total);
        }
      }
    }
  }
  customElements.define('google-reviews', GoogleReviews);

  } catch(e) { console.error(e); }
})();
})();
